import { render, staticRenderFns } from "./thumbnail-gallery.vue?vue&type=template&id=3216dc3e&"
import script from "./thumbnail-gallery.vue?vue&type=script&lang=js&"
export * from "./thumbnail-gallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports